import { cn } from '@/lib/utils'
import { Base } from '@/ui/components'
import React, { memo } from 'react'
import { BaseProps } from '../types'

export interface TitleProps extends Omit<BaseProps, 'as'> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  children?: React.ReactNode
}

const Title = ({ className, as = 'h1', children, ...props }: TitleProps) => {
  if (!children) {
    return null
  }

  return (
    <Base
      as={as}
      className={cn('hyphens-auto', className)}
      {...props}
      dangerouslySetInnerHTML={{ __html: children as string }}
    />
  )
}
Title.displayName = 'Title'

export default memo(Title)
